"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  CREATE: "@@content/create",
  UPDATE: "@@content/update",
  UPDATE_PUBLISH: "@@content/update-publish",
  DELETE: "@@content/delete",
  ADD_ACCESS_PERMISSION: "@@content/add-access-permission",
  UPDATE_ACCESS_PERMISSION: "@@content/update-access-permission",
  LIST_ACCESS_PERMISSION: "@@content/list-access-permission",
  CHECK_VALID_CP_NAME: "@@content/check-valid-cp-name",
  LIST_CP_SLIDES: "@@content/list-cp-slides",
  DUPLICATE: "@@content/duplicate",
  SEND_NOTIFICATION: "@@content/send-notification",
  SAVE_AS_DRAFT: "@@content/save-as-draft",
  SUCCESS: "@@content/success",
  ERROR: "@@content/error",
  RESET: "@@content/reset",
  CREATE_ROOT_NODE: "@@content/create-root-node",
  EDITOR_LOCK: "@@content/editor-lock",
  EDITOR_UNLOCK: "@@content/editor-unlock",
  RESET_EDITOR_LOCK: "@@content/reset_editor-lock",
  RESET_EDITOR_UNLOCK: "@@content/reset_editor-unlock",
  EDITOR: "@@content/editor",
  SOFT_DELETE: "@@content/soft_delete",
  LIST_SOFT_DELETE: "@@content/list_soft_delete",
  BULK_SOFT_DELETE: "@@content/bulk_soft_delete",
  SOFT_RESTORE: "@@content/restore",
  BULK_SOFT_RESTORE: "@@content/bulk_soft_restore",
  BULK_HARD_DELTETE: "@@content/bulk_hard_delete",
  FETCH_SOFT_DELETED: "@@content/fetch_soft_deleted"
};
exports.actionTypes = actionTypes;